import { render, staticRenderFns } from "./work-bench.vue?vue&type=template&id=9f45812c&scoped=true"
import script from "./work-bench.vue?vue&type=script&lang=js"
export * from "./work-bench.vue?vue&type=script&lang=js"
import style0 from "./work-bench.vue?vue&type=style&index=0&id=9f45812c&prod&lang=scss&scoped=true"
import style1 from "./work-bench.vue?vue&type=style&index=1&id=9f45812c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f45812c",
  null
  
)

export default component.exports